// File Name: Whypaymehero.jsx

import React from "react";

import heroImg from "../../assets/EMP_whyus/hero.webp";
import Businessleader from "../../Components/EmployersComponents/whypayme/Businessleader";
import LeadSection from "../../Components/EmployersComponents/whypayme/LeadSection";
import LovedByBusinesses from "../../Components/EmployersComponents/whypayme/LovedByBusinesses";
import BetterBenifits from "../../Components/EmployersComponents/whypayme/BetterBenifits";
import Footer from "../../Components/Footer";

function Whypaymehero() {
  return (
    <section className="w-full bg-[white]">
      <div
        className="
          max-w-full
          mx-auto

          px-6
          sm:px-10
          lg:px-16
          xl:px-24

          py-14
          lg:py-24
        "
      >
        <div
          className="
            grid
            grid-cols-1
            lg:grid-cols-2

            gap-14
            items-center
          "
        >
          {/* LEFT CONTENT */}
          <div className="max-w-[820px] lg:max-w-[720px] lg:-m-6">
            <h1
              className="
                text-[#290001]

                text-[56px]
                font-[var(--primary-font-h4)] 
                sm:text-[74px]
                md:text-[64px]
                lg:text-[54px]
                lg:font-light

                leading-[0.85]
                lg:leading-[1.1]
                tracking-[1px]
                mt-[80px]
                sm:mt-[60px]
                md:mt-[70px]
                lg:mt-[90px]

              "
            >
 The financial wellness{" "}
  <br className="hidden lg:block" />
  benefit that works            </h1>

            <p
              className="
                mt-6
                md:mt-8
                lg:mt-4

                text-[#111111]

                text-[17px]
                sm:text-[24px]
                md:text-[22px]
                lg:text-[18px]
                lg:font-sans

                leading-[1.1]

                max-w-[650px]
              "
            >
              A new study reports DailyPay as the #1 adopted
              financial wellness <br className="hidden lg:block" /> benefit.
            </p>

            <button
              className="
                mt-8

                bg-[#290001]
                text-white

                px-4
                py-2

                sm:px-8
                sm:py-3
                md:px-6
                md:py-2
                lg:px-4
                lg:py-2

                text-[16px]
                font-bold

                hover:bg-[#4b0002]
                transition-all
                duration-300
              "
            >
              Download the Value Report
            </button>
          </div>

          {/* RIGHT IMAGE */}
      <div
  className="
    flex
    justify-center
    lg:justify-end

    lg:-mt-[80px]

    /* MOBILE ONLY */
    mr-0
    ml-[20px]

    /* TABLET */
    md:ml-[230px]
    md:mr-[-230px]
    md:mt-[-20px]

    /* LAPTOP */
    lg:ml-[30px]
    lg:mr-[-170px]
  "
>
            <img
              src={heroImg}
              alt="Financial wellness"

             className="
  w-full

  max-w-[320px]
  sm:max-w-[420px]
  md:max-w-[500px]
  lg:max-w-[780px]

  h-auto
  object-contain
"
            />
          </div>
        </div>
      </div>

<Businessleader />
<LeadSection />
<LovedByBusinesses />
<BetterBenifits />
<Footer />
    </section>
  );
}

export default Whypaymehero;